import React from 'react'
import HeroSection from './HeroSection'
import Breadcrumb from './Breadcrumb';

function AboutInfo() {
  return (
    <div className='aboutInfo'>
    <div>
    {/* Reusable Hero Section */}
    <HeroSection
      heading="About"
      backgroundImage="/img/about.jpg"
    />
    <Breadcrumb current="About Us" />
    <>
    <div className="container about2">
      <div className="row">
        <div className="col-md-6 text-center">
          <img alt="about" src="./img/scientist.png" className="img-fluid2" />
        </div>
        <div className="col-md-6">
          <h2 className="main-title about-h2">ABOUT US</h2>
          <p className="main-p">
          SEIONIC is a technology application group that applies latest technologies to market, by leveraging its research and application knowledge. It operates in multi-disciplinary domains of Intelligent Transport Management System and Embedded systems. SEIONIC is led by a group of technocrats and researchers, who have been part of technology evolution processes. SEIONIC offers high-end technology support in the form of product design, proto type design, Contract Manufacturing, technology license and consulting services, that enable its clients to meet time to market needs in niche areas.
          </p>
        </div>
      </div>
    </div>
  </> 


  <div className="container about3">
        <div className="row">
          <div className="col-md-6 text-center">
            <img alt="about" src="./img/firmware.jpg" className="about-img4" />
          </div>
          <div className="col-md-6">
            <h2 className="block-h1">VALUE PROPOSITION:
            </h2>

            <p className='points-p'> Strong technology team with hands on experience in Embedded Systems, communication, wireless, system design, control system, networking, and  product design.</p>
            <ul className="points-list" >
  <li>Proven product development process </li>
  <li>Continuing Training system and process</li>
  <li>Strong network of professionals for rapid ramping of the team as per requirement</li>
  <li>Patent and IPR filing, drafting, validation and valuation system available for the client outsourcing the work</li>
  <li>State of the art lab with a versatile range of equipments and licensed tools
  Sate of the art Contract Manufacturing Facility</li>
</ul>
          </div>
        </div>
      </div>
    </div>
  </div>
    
  )
}

export default AboutInfo;